import Bell from "../assets/icon/svgs/Bell.svg";

type NotifyBellProps = {
  notifications: number;
};

const NotifyBell: React.FC<NotifyBellProps> = ({ notifications }) => {
  return (
    <div className="relative cursor-pointer w-[24px] h-[24px]">
      <img src={Bell} alt="Bell" />
      {notifications > 0 && (
        <div className="absolute top-[-8px] right-[-6px] rounded-full bg-red-common flex items-center justify-center text-white aspect-square min-w-5 min-h-5 text-sm">
          {notifications}
        </div>
      )}
    </div>
  );
};

export default NotifyBell;
